// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__9b6vo","isHovered":"IconButton_isHovered__VAGTv","icon":"IconButton_icon__6_lhQ"};